import { render } from "./MainContent.vue?vue&type=template&id=c59a8648&scoped=true"
const script = {}

import "./MainContent.vue?vue&type=style&index=0&id=c59a8648&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c59a8648"]])

export default __exports__